/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Sticker(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M168,32H88A56.0629,56.0629,0,0,0,32,88v80a56.0629,56.0629,0,0,0,56,56h48a8.0151,8.0151,0,0,0,2.53027-.41016c26.23243-8.74511,76.31446-58.82714,85.05957-85.05957A8.0151,8.0151,0,0,0,224,136V88A56.0629,56.0629,0,0,0,168,32ZM136,207.42236V176a40.04584,40.04584,0,0,1,40-40h31.42236C198.15991,157.55176,157.55176,198.16016,136,207.42236Z" />
    </Svg>
  );
}

export default Sticker;
